import { Component, OnInit } from '@angular/core';
import { ApiImportService } from '../../services/api-import.service';
import { ApiImportSubscription } from 'src/app/benutzer-verwaltung/parameter/models/apiImportSubscription';
import { ApiImportDeadline } from 'src/app/benutzer-verwaltung/parameter/models/apiImportDeadline';
import { CommonUtilsService } from 'src/app/shared/services/common-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiImportParam, ApiImportParamOption } from 'src/app/benutzer-verwaltung/parameter/models/apiImportParams';
import { ApiImportParamsService } from 'src/app/benutzer-verwaltung/parameter/service/api-import-params.service';
import { Router } from '@angular/router';
import { stringToBoolean } from 'src/app/shared/util/string-to-boolean';

@Component({
  selector: 'app-api-import',
  templateUrl: './api-import.component.html',
  styleUrls: ['./api-import.component.scss']
})
export class ApiImportComponent implements OnInit {

  public spinnerFlag = true;
  public deadlines: any[] = []; 
  public selectedDeadline: any;
  public isSubscriptionEnabled: boolean;
  public nextSubscriptionDeadline: Date;
  
  apiImportParams: ApiImportParam[] = [];
  apiImportParamsOrigin: ApiImportParam[] = [];

  constructor(
    private apiImportService: ApiImportService,
    private apiImportParamsService: ApiImportParamsService,
    private commonUtils: CommonUtilsService,
    private translateService: TranslateService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.reloadData();
  }

  reloadData() {
    this.selectedDeadline = null;
    this.getMonthUltimos();
    this.getSubscriptionState();
    this.getApiImportParams();
  }



  onDeadlineSelectionChanged(deadline) {
    //console.log(deadline);
  }

  getMonthUltimos() {
    this.spinnerFlag = true

    this.apiImportService.getMonthUltimos().subscribe((res: any) => {
      if (res.Result) {
      this.spinnerFlag = false

        this.deadlines = res.Result;
        if (this.deadlines.length > 0) {

        } else {
          
        }
      }
    });
  }

  getSubscriptionState() {
    this.spinnerFlag = true;

    this.apiImportService.getApiImportSubscrition().subscribe(
      (res: any) => {
        this.spinnerFlag = false;
        //console.log(res.Result);
        if (res.Result)
        {
          this.isSubscriptionEnabled = stringToBoolean(res.Result.isActive);

          if (res.Result?.nextDeadline) {
            this.nextSubscriptionDeadline = res.Result?.nextDeadline;
          } else {
            this.nextSubscriptionDeadline = this.translateService.instant('unknown');
          }
        }
        
      }, (err: any) => {
        this.spinnerFlag = false;
        console.log(err);
        this.commonUtils.errorSnackBar('error', this.translateService.instant('deadlineSubscriptionError'));
      }
    );
  }

  orderDeadline() {
    if (this.selectedDeadline) {
        this.spinnerFlag = true;
        console.log(this.selectedDeadline);
        let apiImportDeadlineData: ApiImportDeadline = { deadline: this.selectedDeadline, importParams: this.apiImportParams }

        this.apiImportService.createApiImportDeadline(apiImportDeadlineData).subscribe(
          (res: any) => {
            this.spinnerFlag = false;
            //console.log(res.Result);
            this.commonUtils.successSnackBar(this.translateService.instant('deadlineOrderSuccessful'));
            this.reloadData();
          }, (err: any) => {
            this.spinnerFlag = false;
            console.log(err);

            if (err.error.Result?.internalErrorCode == 40001) {
              this.commonUtils.errorSnackBar('error', this.translateService.instant('deadlineOrderNotAllowed'));
            }
            else if (err.error.Result?.internalErrorCode == 40901) {
              this.commonUtils.errorSnackBar('error', this.translateService.instant('deadlineAlreadyExists'));
            }
            else if (err.error.Result?.internalErrorCode == 40004) {
              if (err.error.Result?.validationResult?.errors?.length > 0) {
                let errorMessage = this.translateService.instant('checkApiImportParamSelection');
                err.error.Result?.validationResult?.errors.forEach(error => {
                  errorMessage += '\n\n' + this.translateService.instant(error.paramTypeTranslationKey) + this.translateService.instant('minSelectionCount') + error.minSelectionCount;
                });
                this.commonUtils.errorSnackBar('error', errorMessage, this.getImportErrorParamterDisplayDuration(err.error.Result?.validationResult?.errors?.length));
              }
            }
            else {
              this.commonUtils.errorSnackBar('error', this.translateService.instant('deadlineOrderError'));
            }
          }
        );
    }
  }

  toggleSubscription(state) {
    this.spinnerFlag = true;

    let apiImportSubscriptionData: ApiImportSubscription = { isActive: state }

    this.apiImportService.setApiImportSubscrition(apiImportSubscriptionData).subscribe(
      (res: any) => {
        this.spinnerFlag = false;
        //console.log(res.Result);

        if (res.Result) {
          const isActive =
            res.Result.isActive === true ||
            res.Result.isActive === 'true';

          if (isActive) {
            this.commonUtils.successSnackBar(this.translateService.instant('apiImportSubscriptionEnabled'));
          } else {
            this.commonUtils.successSnackBar(this.translateService.instant('apiImportSubscriptionDisabled'));
          }

          if (res.Result?.nextDeadline) {
            this.nextSubscriptionDeadline = res.Result?.nextDeadline;
          } else {
            this.nextSubscriptionDeadline = this.translateService.instant('unknown');
          }
        }
      }, (err: any) => {
        this.spinnerFlag = false;
        this.isSubscriptionEnabled = false;
        console.log(err);
        if (err.error.Result?.internalErrorCode == 40005) {
          if (err.error.Result?.validationResult?.errors?.length > 0) {
            let errorMessage = this.translateService.instant('checkApiImportParamDefaultConfig');
            err.error.Result?.validationResult?.errors.forEach(error => {
              errorMessage += '\n\n' + this.translateService.instant(error.paramTypeTranslationKey) + this.translateService.instant('minSelectionCount') + error.minSelectionCount;
            });

            this.commonUtils.errorSnackBar('error', errorMessage, this.getImportErrorParamterDisplayDuration(err.error.Result?.validationResult?.errors?.length));
          }
        }
        else {
          this.commonUtils.errorSnackBar('error', this.translateService.instant('deadlineSubscriptionError'));
        }
      }
    );
  }

  getApiImportParams() {
    this.apiImportParamsService.getApiImportParams().subscribe((response: ApiImportParam[]) => {
      this.spinnerFlag = false;
      this.setData(response);
    }, (error) => {
      this.spinnerFlag = false;
      this.commonUtils.errorSnackBar('error', '');
    });
  }

  setData(data: ApiImportParam[]) {
    this.apiImportParams = data;
    //Create deep copy of orinal params for resetting
    this.apiImportParamsOrigin = JSON.parse(JSON.stringify(this.apiImportParams));
  }

  navigateToImportParams() {
    this.router.navigate(['bv-home/api-import-params']);
  }

  apiImportParamOptionCheckedChanged(param: ApiImportParamOption) {
      param.selected = !param.selected;
    }

  getImportErrorParamterDisplayDuration(errorsCount: any) {
    if (errorsCount && errorsCount > 4) {
      return 12000;
    } else {
      return errorsCount && errorsCount > 1 ? errorsCount * 3000 : undefined; // undefined: snackbar uses default duration
    }
  }

}
